// src/components/StripeProvider.jsx
import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

// Use your test publishable key (replace with live when ready)
const stripePromise = loadStripe('pk_test_51QzjxU4D536Usvph5mI8ecnYEyK6GJlGfrCjkm8x8cmAghZi1Uh0pDT00KOu0sVA2');

const StripeProvider = ({ children }) => {
  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export default StripeProvider;